module.exports = __webpack_public_path__ + "img/bg-banner-account-dark.815fe3d5.png";